module.exports = __webpack_public_path__ + "img/111.945529e0.png";